import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huoban",
  "use": "icon-huoban-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-huoban\"><path d=\"M7.24 2.501a5.068 5.068 0 015.063 4.848l.004.22a5.063 5.063 0 01-2.23 4.199 7.237 7.237 0 014.402 6.66h-1.448a5.792 5.792 0 00-11.583 0H0a7.242 7.242 0 014.401-6.662A5.068 5.068 0 017.24 2.501zM17.926 5.98a4.708 4.708 0 01-1.828 5.072 6.514 6.514 0 013.811 5.929h-1.448a5.068 5.068 0 00-5.068-5.068v-1.448a3.258 3.258 0 10-.857-6.404l-.38-1.397a4.706 4.706 0 015.77 3.316zM7.24 3.95a3.62 3.62 0 103.615 3.811l.005-.192a3.62 3.62 0 00-3.428-3.615L7.24 3.95z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/huoban.svg
// module id = 477
// module chunks = 4